export const DELIVERY_MINIMUM_ORDER = Number(process.env.REACT_APP_DELIVERY_MINIMUM_ORDER) || 12;

export const deliveryShortfall = (subtotal) =>
  Math.max(0, Math.round((DELIVERY_MINIMUM_ORDER - Number(subtotal || 0)) * 100) / 100);
